import { render, staticRenderFns } from "./ShareMyAdvisorModal.vue?vue&type=template&id=bc4b5baa&scoped=true&"
import script from "./ShareMyAdvisorModal.vue?vue&type=script&lang=js&"
export * from "./ShareMyAdvisorModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareMyAdvisorModal.vue?vue&type=style&index=0&id=bc4b5baa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b5baa",
  null
  
)

export default component.exports